<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <b-col md="12" class="mb-2">
          <h5>Pegawai Baru</h5>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="Role"
            label="Role"
          >
            <v-select
              id="role"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="roleOption.options"
              v-model="tempUserData.role"
              placeholder="Pilih Role"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label-for="Nama"
            label="Nama"
          >
            <b-form-input
              id="nama"
              placeholder="nama"
              v-model="tempUserData.nama"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Email"
            label="Email"
          >
            <b-form-input
              id="email"
              placeholder="email"
              v-model="tempUserData.email"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Password"
            label="Password"
          >
            <b-form-input
              id="password"
              placeholder="password"
              v-model="tempUserData.password"
              :type="'password'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="NIP"
            label-for="nip"
          >
             <b-form-input
              id="nip"
              placeholder="NIP"
              v-model="tempUserData.nip_nup"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Sisa Cuti"
            label-for="sisa_cuti"
          >
             <b-form-input
              id="sisa_cuti"
              placeholder="Sisa Cuti"
              v-model="tempUserData.sisa_cuti"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Tempat Lahir"
            label-for="tempat_lahir"
          >
             <b-form-input
              id="tempat_lahir"
              placeholder="Tempat Lahir"
              v-model="tempUserData.tempat_lahir"
            />
          </b-form-group>
        </b-col>
        <!-- birth date -->
        <b-col md="6">
          <b-form-group
            label-for="example-datepicker"
            label="Tanggal Lahir"
          >
            <flat-pickr
              class="form-control"
              name="date"
              placeholder="2023-01-01"
              v-model="tempUserData.tanggal_lahir"
            />
          </b-form-group>
        </b-col>
        <!--/ birth date -->
        <b-col cols="6">
          <b-form-group
            label="Usia"
            label-for="usia"
          >
             <b-form-input
              id="usia"
              placeholder="Usia"
              v-model="tempUserData.usia"
              type="number"
            />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group
            label="Tahun Pensiun"
            label-for="tahun_pensiun"
          >
             <b-form-input
              id="pensiun"
              placeholder="pensiun"
              v-model="tempUserData.pensiun"
              type="number"
            />
          </b-form-group>
        </b-col>

         <b-col md="6">
          <b-form-group
            label-for="gender"
            label="Jenis Kelamin"
          >
            <v-select
              id="gender"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="jenisKelaminOption.options"
              v-model="tempUserData.jenis_kelamin_id"
              placeholder="Pilih Jenis Kelamin"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Status Pegawai"
            label="Status Pegawai"
          >
            <v-select
              id="status_pegawai"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="statusPegawaiOption.options"
              v-model="tempUserData.status_pegawai_id"
              placeholder="Pilih Status Pegawai"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Jabatan"
            label="Jabatan"
          >
            <v-select
              id="jabatan"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="jabatanOption.options"
              v-model="tempUserData.jabatan_id"
              placeholder="Pilih Jabatan"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Unit Kerja"
            label="Unit Kerja"
          >
            <v-select
              id="unit_kerja"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="unitKerjaOption.options"
              v-model="tempUserData.unit_kerja_id"
              placeholder="Pilih Unit Kerja"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Pangkat"
            label="Pangkat"
          >
            <v-select
              id="pangkat"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="pangkatOption.options"
              v-model="tempUserData.pangkat_id"
              placeholder="Pilih Pangkat"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Golongan"
            label="Golongan"
          >
            <v-select
              id="Golongan"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="golonganOption.options"
              v-model="tempUserData.golongan_id"
              placeholder="Pilih Golongan"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Pendidikan"
            label="Pendidikan"
          >
            <v-select
              id="Pendidikan"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="pendidikanOption.options"
              v-model="tempUserData.pendidikan_id"
              placeholder="Pilih Pendidikan"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Atasan"
            label="Atasan"
          >
            <v-select
              id="Atasan"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="atasanOption.options"
              v-model="tempUserData.atasan_id"
              placeholder="Pilih Atasan"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="Penandatangan"
            label="Penandatangan"
          >
            <v-select
              id="Penandatangan"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :reduce="val => val.value"
              :options="penandatanganOption.options"
              v-model="tempUserData.penandatangan_id"
              placeholder="Pilih Penandatangan"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            v-if="tempUserData.status_pegawai_id == 4"
            label="Masuk SIPEG"
            label-for="masuk_sipeg"
          >
             <b-form-datepicker
              id="masuk_sipeg"
              placeholder="Masuk Sipeg"
              v-model="tempUserData.masuk_sipeg"
            />
          </b-form-group>
          <b-form-group
            v-else
            label="Masuk SK Fakultas"
            label-for="masuk_sk_fak"
          >
            <b-form-datepicker
              id="masuk_sk_fak"
              placeholder="Masuk SK Fakultas"
              v-model="tempUserData.masuk_sk_fak"
            />
          </b-form-group>
         
        </b-col>
      </b-row>

        <b-row>
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              @click="simpanPegawaiBaru()"
            >
              Simpan
            </b-button>
          </b-col>
        </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BFormTextarea, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import {
  getAllMasterUUID,
  postPegawaiBaru,
} from '@/connection-api/pengajuan-cuti/api'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    vSelect,
    flatPickr,
    Cleave,
    BFormDatepicker,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tempUserData: {},
      tahunOptions: [],
      jenisKelaminOption: {},
      statusPegawaiOption: {},
      jabatanOption: {},
      unitKerjaOption: {},
      pangkatOption: {},
      golonganOption: {},
      pendidikanOption: {},
      atasanOption: {},
      penandatanganOption: {},
      roleOption: {},
    }
  },
  mounted() {
    // this.populateYearOptions()
    if(this.$route.query.sync == 'yes')
    {
      alert('SSO Berhasil Tersingkronisasi')
    }
    if(this.$route.query.error_message)
    {
      alert(this.$route.query.error_message)
    }
    this.getMasterData()
    // this.getDetailBiodata()
  },
  methods: {
    getDetailBiodata()
    {
      getDetailBiodataUUID(this.$route.params.uuid)
      .then(response => {
        if (response.data.success == true) {
          this.tempUserData = response.data.data
        }
      })
      .catch(error => {
      });
    },
    simpanPegawaiBaru()
    {
      postPegawaiBaru(this.tempUserData)
      .then(response => {
        if (response.data.success == true) {
          alert('Data Berhasil Dibuat')
          setTimeout(() => {
            this.$router.push({name: 'list-pegawai'})
          }, 3000);
        } else {
          alert(response.data.message)
        }
      })
      .catch(error => {
      });
    },
    getMasterData(){
      getAllMasterUUID()
      .then(response => {
        if (response.data.success == true) {
          var jenis_kelamin = response.data.data.jenis_kelamin
          var status_pegawai = response.data.data.status_pegawai
          var jabatan = response.data.data.jabatan
          var unit_kerja = response.data.data.unit_kerja
          var pangkat = response.data.data.pangkat
          var golongan = response.data.data.golongan
          var pendidikan = response.data.data.pendidikan
          var atasan = response.data.data.atasan
          var penandatangan = response.data.data.penandatangan
          var role = response.data.data.role
          if(jenis_kelamin.length > 0)
          {
            this.jenisKelaminOption = this.handleBuildOption(jenis_kelamin)
          }
          if(status_pegawai.length > 0)
          {
            this.statusPegawaiOption = this.handleBuildOption(status_pegawai)
          }
          if(jabatan.length > 0)
          {
            this.jabatanOption = this.handleBuildOption(jabatan)
          }
          if(unit_kerja.length > 0)
          {
            this.unitKerjaOption = this.handleBuildOption(unit_kerja)
          }
          if(pangkat.length > 0)
          {
            this.pangkatOption = this.handleBuildOption(pangkat)
          }
          if(golongan.length > 0)
          {
            this.golonganOption = this.handleBuildOption(golongan)
          }
          if(pendidikan.length > 0)
          {
            this.pendidikanOption = this.handleBuildOption(pendidikan)
          }
          if(atasan.length > 0)
          {
            this.atasanOption = this.handleBuildOption(atasan)
          }
          if(penandatangan.length > 0)
          {
            this.penandatanganOption = this.handleBuildOption(penandatangan)
          }
          if(role.length > 0)
          {
            this.roleOption = this.handleBuildOptionRole(role)
          }
        }
      })
      .catch(error => {
      });
    },
    handleBuildOption(dataTemp){
      let params = {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Data--' },
        ],
      }
      dataTemp.forEach(element => {
          params.options.push({
            title: element.nama,
            value: element.id,
          })
        })
      return params
    },
    handleBuildOptionRole(dataTemp){
      let params = {
        selected: 'ids',
        options: [
          { value: null, title: '--Pilih Data--' },
        ],
      }
      dataTemp.forEach(element => {
          params.options.push({
            title: element.nama,
            value: element.ids,
          })
        })
      return params
    }
    // populateYearOptions() {
    //   const currentYear = new Date().getFullYear();
    //   const yearsToShow = 30; // Adjust this number as needed to show more or fewer years

    //   for (let i = currentYear; i >= currentYear - yearsToShow; i--) {
    //     this.tahunOptions.push({ value: i, title: i.toString() });
    //   }
    // },
    // async changeKota(provinsiId, onFirst = null) {
    //   this.kotaOption = {
    //     selected: 'id',
    //     options: [
    //       { value: null, label: '--Pilih Kota --' },
    //     ],
    //   }

      // getKota(provinsiId)
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.kotaOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      // }
      // })
      // .catch(error => console.log(error));

      // if(onFirst == null)
      // {
      //   this.tempUserData.kota_id = null
      // }
      
      
    },
    //Function
    async simpanData() {
      this.tempUserData.flag = 'info'
      const response = await ubahUserData(this.tempUserData)
      if (response.data.success === true) {
        this.makeToast('success', 'Data berhasil disimpan.')
      } else {
        this.makeToast('danger', response.data.message)
      }
    },
     makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Biodata',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  }
// }
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
